export const APPEALS_ACTIONS = {
  CREATE: 'APPEALS_CREATE'
};